import { createAction } from 'redux-actions'
import {
  ADD_UNIT_NO,
  ADD_UNIT_NO_FAILED,
  ADD_UNIT_NO_SUCCEEDED,
  CLEAR_CREATED_UNIT_NO,
  DELETE_UNIT_NO,
  DELETE_UNIT_NO_FAILED,
  DELETE_UNIT_NO_SUCCEEDED,
  GET_UNIT_NUMBERS,
  GET_UNIT_NUMBERS_FAILED,
  GET_UNIT_NUMBERS_SUCCEEDED,
} from 'Redux/Types/UnitNoTypes'

export const deleteUnitNo = createAction(DELETE_UNIT_NO)
export const deleteUnitNoFailed = createAction(DELETE_UNIT_NO_FAILED)
export const deleteUnitNoSucceeded = createAction(DELETE_UNIT_NO_SUCCEEDED)

export const getUnitNumbers = createAction(GET_UNIT_NUMBERS)
export const getUnitNumbersFailed = createAction(GET_UNIT_NUMBERS_FAILED)
export const getUnitNumbersSucceeded = createAction(GET_UNIT_NUMBERS_SUCCEEDED)

export const addUnitNo = createAction(ADD_UNIT_NO)
export const addUnitNoFailed = createAction(ADD_UNIT_NO_FAILED)
export const addUnitNoSucceeded = createAction(ADD_UNIT_NO_SUCCEEDED)
export const clearCreatedUnitNo = createAction(CLEAR_CREATED_UNIT_NO)
